import { Config } from './typings/Config'
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import AssessmentIcon from '@mui/icons-material/Assessment'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import GridViewIcon from '@mui/icons-material/GridView'
import TuneIcon from '@mui/icons-material/Tune'
import PeopleIcon from '@mui/icons-material/People'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import SellIcon from '@mui/icons-material/Sell'
import StyleIcon from '@mui/icons-material/Style'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import OutboxIcon from '@mui/icons-material/Outbox'
import SwipeIcon from '@mui/icons-material/Swipe'
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';

import {
  ZonePage,
  PickingPage,
  PickingValidatePage,
  ProcessNew,
  WorkOrderDashboardPage,
  DashBoardPage,
  FillRatePage,
  StockMovementNewPage,
  ConfigurationPage,
  //CheckPage,
  ReturnsPage,
  PositionAlertsPage,
  WorkOrderOutboundPage,
  ProductOriginPage,
  PickingRouteAdminPage,
  TypePriorityPage,
  ASNAdjustmentPage,
  NewTypePositionPage,
  PositionPageNew,
  UserPageNew,
  LayoutMapPage
} from './pages/'

import {
  SUPER_ADMIN,
  ADMIN_CONFIGURATOR,
  PICKER,
  WAREHOUSE_SUPERVISOR,
  PUTAWAY,
  DISPATCHER,
  ADMUSER
} from './config/roles'
import { PickingReportPage } from './pages/PickingReport/PickingReportPage'
import { KardexPage } from './pages/Kardex/KardexPage'
import { StockReservePage } from './pages/StockReserve/StockReservePage'
import { PreSaleSkuPage } from './pages/PreSaleSku/PreSaleSkuPage'
import { CourierPage } from './pages/Courier/CourierPage'
import { WebhookPage } from './pages/Webhook/WebhookPage'
import { NewStockPages } from './pages/Stock/NewStockPages'
import { ExternalAuditPage } from './pages/ExternalAudit/ExternalAuditPage'
import { NewProductPage } from './pages/Productos/NewProductPage'
import { InventoryCheckPage } from './pages/InventoryCheck/InventoryCheckPage'
import InventoryCheckHandheldPage from './pages/InventoryCheckHandheld/InventoryCheckPage'
import { WorkOrderRecallPage } from './pages/WorkOrderRecall/WorkOrderRecallPage'
import { RestockOrderPage } from './pages/RestockOrder/RestockOrderPage'
import { DispatchOtNewPage } from './pages/DispatchOtNew'
import { SupplierPage } from './pages/Supplier20'
import { ASNPage } from './pages/ASN20'
import { AsnDetailsQueryPage } from './pages/AsnDetailsQuery'
import { SupplierOriginPage } from './pages/SupplierOrigin20/SupplierOriginPage'
import NewRelocatePage from './pages/NewRelocate/NewRelocatePage'
import { OrderPage } from './pages/OrderPage'
import { PackingListNewPage } from './pages/PackingList/PackingListNewPage'
import { TypeVasPage } from './pages/TypeVas/TypeVasPage'
import { VasRulePage } from './pages/VasRule/VasRulePage'
import { ProductAdminPage } from './pages/ProductAdmin/ProductAdminPage'
import { StockMobile } from './pages/Mobile/Stock/stockMobile'
import { WarehousePage } from './pages/Warehouse/WarehousePage'
import { SettingsPage } from './pages/Settings/SettingsPage'
import { ProductExternalReferencePage } from './pages/ProductExternalReference'
import { ProductOriginTechnicalPage } from './pages/ProductOriginTechnical'
import AsnLocatePage from './pages/ASNLocateNew/AsnLocatePage'
import { UserAdminPage } from './pages/UserAdmin/UserAdminPage'
import AsnReceptionLpnPage from './pages/ASNReceptionLpnNew/AsnReceptionLpnPage'
import { OrderOriginPage } from './pages/OrderOriginPage/OrderOriginPage'
import { CourierCollectionPlannerPage } from './pages/CourierCollectionPlanner/CourierCollectionPlannerPage'

const style = {
  identation: '20px'
}

export const configuration: Config = {
  name: 'wms',
  iconUrl: 'wms',
  url: '/wms',
  visibleName: 'WMS',
  submenus: [
    // INGRESO DE MERCADERIA
    {
      component: undefined,
      name: 'Recepciones',
      url: '',
      roles: [SUPER_ADMIN],
      icon: MoveToInboxIcon,
      items: [
        {
          component: PackingListNewPage,
          name: 'Packing List',
          url: 'merchandise/newpackinglist',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Creación de Packing List'
        },
        {
          component: ASNPage,
          name: 'ASN',
          url: 'merchandise/asn',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Gestión de ASN'
        },
        {
          component: AsnDetailsQueryPage,
          name: 'Detalle ASN',
          url: 'merchandise/asndetails',
          roles: [WAREHOUSE_SUPERVISOR, PUTAWAY],
          identation: style.identation,
          headerName: 'Consulta de Ítems de ASN'
        },
        {
          component: AsnReceptionLpnPage,
          name: 'Recepcionar LPN',
          url: 'merchandise/newreceptionlpn',
          roles: [PUTAWAY],
          identation: style.identation,
          visibility: 'both'
        },
        // {
        //   component: PutAwayPage,
        //   name: 'Ubicar Productos',
        //   url: 'merchandise/ubication',
        //   roles: [PUTAWAY],
        //   identation: style.identation,
        //   visibility: 'both'
        // },
        {
          component: AsnLocatePage,
          name: 'Ubicar Productos',
          url: 'merchandise/ubication-new',
          roles: [PUTAWAY],
          identation: style.identation,
          visibility: 'both'
        },
        {
          component: ASNAdjustmentPage,
          name: 'Ajuste ASN',
          url: 'merchandise/adjustmentv2',
          roles: [PUTAWAY],
          identation: style.identation,
          headerName: 'Ajuste de ASN'
        }
      ]
    },
    // DEVOLUCIONES
    {
      component: undefined,
      name: 'Devoluciones',
      url: '',
      roles: [SUPER_ADMIN],
      icon: OutboxIcon,
      items: [
        {
          component: ReturnsPage,
          name: 'Devoluciones',
          url: 'returns',
          roles: [PUTAWAY],
          identation: style.identation,
          headerName: 'Gestión de Devoluciones'
        }
      ]
    },
    // PLANNER
    {
      component: undefined,
      name: 'Gestión de órdenes',
      url: '',
      roles: [SUPER_ADMIN],
      icon: CalendarMonthIcon,
      items: [
        {
          component: OrderPage,
          name: 'Pedidos',
          url: 'planner/order',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Gestión de Pedidos'
        },
        {
          component: WorkOrderOutboundPage,
          name: 'Órdenes de salida',
          url: 'workOrderOutbound',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },

    // PICKING
    {
      component: undefined,
      name: 'Picking',
      url: '',
      roles: [SUPER_ADMIN],
      icon: ShoppingCartIcon,
      items: [
        {
          component: PickingRouteAdminPage,
          name: 'Gestionar Rutas',
          url: 'picking/newadmin',
          roles: [PICKER],
          identation: style.identation,
          headerName: 'Rutas de Picking'
        },
        {
          component: PickingPage,
          name: 'Ejecutar ruta',
          url: 'picking/route',
          roles: [PICKER],
          identation: style.identation,
          visibility: 'both'
        },
        {
          component: PickingValidatePage,
          name: 'Validar Ruta',
          url: 'picking/validate',
          roles: [PICKER],
          identation: style.identation,
          headerName: 'Validar Ruta de Picking'
        }
      ]
    },
    // INVENTARIO
    {
      component: undefined,
      name: 'Inventario',
      url: '',
      roles: [SUPER_ADMIN],
      icon: Inventory2Icon,
      items: [
        {
          component: NewStockPages,
          name: 'Stock',
          url: 'inventory/stock',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Consulta de Stock'
        },
        {
          component: StockMobile,
          name: 'Consultar Stock',
          url: 'inventory/stockMobile',
          roles: [PUTAWAY],
          identation: style.identation,
          visibility: 'mobile'
        },
        {
          component: NewRelocatePage,
          name: 'Reubicar Productos',
          url: 'inventory/newrelocate',
          roles: [PUTAWAY],
          identation: style.identation,
          visibility: 'both'
        },
        {
          component: StockMovementNewPage,
          name: 'Historial de Stock',
          url: 'inventory/stockmovementnew',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Consulta de Historial de Stock'
        },
        {
          component: PositionAlertsPage,
          name: 'Alertas',
          url: 'picking/positionAlerts',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Alertas de Inventario'
        },
        {
          component: StockReservePage,
          name: 'Stock y Reservas',
          url: 'inventory/stockReserve',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: PreSaleSkuPage,
          name: 'Venta en verde',
          url: 'presalesku',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Stock de Venta en Verde'
        },
        {
          component: KardexPage,
          name: 'Kardex',
          url: 'kardex',
          roles: [SUPER_ADMIN, WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Kardex'
        }
      ]
    },
    {
      component: undefined,
      name: 'Auditoría de Inventario',
      url: '',
      icon: PendingActionsIcon,
      roles: [SUPER_ADMIN],
      items: [
        {
          component: InventoryCheckPage,
          name: 'Conteos',
          url: 'inventoryCheck',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Conteos de Inventario'
        },
        {
          component: InventoryCheckHandheldPage,
          name: 'Ejecutar conteo',
          url: 'inventorycheckhh',
          roles: [PUTAWAY],
          identation: style.identation,
          visibility: 'both'
        },
        {
          component: WorkOrderRecallPage,
          name: 'Recall',
          url: 'workorderrecall',
          headerName: 'Recall de Producto',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },
    // SALIDA DE MERCADERIA
    {
      component: undefined,
      name: 'Despacho',
      url: '',
      roles: [SUPER_ADMIN],
      icon: LocalShippingIcon,
      items: [
        {
          component: DispatchOtNewPage,
          name: 'Despachar OT',
          url: 'merchandise/newdispatchot',
          roles: [DISPATCHER],
          identation: style.identation,
          headerName: 'Despacho de Órdenes'
        }
        // {
        //   component: CarrierPageV3,
        //   name: 'Gestionar Transportista',
        //   url: 'merchandise/carrier',
        //   roles: [DISPATCHER],
        //   identation: style.identation
        // },
        // {
        //   component: CheckPage,
        //   name: 'Entrada/Salida Transportista',
        //   url: 'merchandise/checkinout',
        //   roles: [DISPATCHER],
        //   identation: style.identation
        // }
      ]
    },
    // REPORTERIA
    {
      component: undefined,
      name: 'Reportes',
      url: '',
      roles: [SUPER_ADMIN],
      icon: AssessmentIcon,
      items: [
        {
          component: DashBoardPage,
          name: 'Picking',
          url: 'report/picking',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Reporte de Picking'
        },
        {
          component: PickingReportPage,
          name: 'Avance Picking',
          url: 'report/pickingworkflow',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Avance de Picking'
        },
        {
          component: FillRatePage,
          name: 'OT',
          url: 'report/fillrate',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Reporte de OT'
        },
        {
          component: WorkOrderDashboardPage,
          name: 'Avances OT',
          url: 'report/workorder',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Avance de Órdenes'
        }
      ]
    },
    // PRODUCTOS
    {
      component: undefined,
      name: 'Productos',
      url: '',
      roles: [SUPER_ADMIN],
      icon: SellIcon,
      items: [
        {
          component: NewProductPage,
          name: 'Catálogo',
          url: 'inventory/newproduct',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Catálogo de Productos'
        },
        {
          component: ProductAdminPage,
          name: 'Configuración',
          url: 'adminProduct',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Configuración de Productos'
        }
      ]
    },
    // Personalizaciones
    {
      component: undefined,
      name: 'Personalizaciones',
      url: '',
      roles: [SUPER_ADMIN],
      icon: AutoFixHighIcon,
      items: [
        {
          component: TypeVasPage,
          name: 'Tipos de VAS',
          url: 'typeVas',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Tipos de VAS'
        },
        {
          component: VasRulePage,
          name: 'Reglas de VAS',
          url: 'VasRule',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Reglas de VAS'
        }
      ]
    },
    // LAYOUT
    {
      component: undefined,
      name: 'Layout',
      url: '',
      roles: [SUPER_ADMIN],
      icon: GridViewIcon,
      items: [
        {
          component: WarehousePage,
          name: 'Almacenes',
          url: 'inventory/warehouse-new',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Almacenes'
        },
        {
          component: ZonePage,
          name: 'Zonas',
          url: 'inventory/zone',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Zonas'
        },
        {
          component: PositionPageNew,
          name: 'Posiciones',
          url: 'inventory/position',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Posiciones'
        },
        {
          component: NewTypePositionPage,
          name: 'Tipos de Posición',
          url: 'inventory/typeposition',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: LayoutMapPage,
          name: 'Mapa',
          url: 'inventory/layout-map',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Mapa de Layout'
        }
      ]
    },
    // MAESTROS
    {
      component: undefined,
      name: 'Maestros',
      url: '',
      roles: [SUPER_ADMIN],
      icon: StyleIcon,
      items: [
        {
          component: SupplierPage,
          name: 'Proveedores',
          url: 'merchandise/supplier',
          roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Proveedores'
        },
        {
          component: SupplierOriginPage,
          name: 'Origenes',
          url: 'merchandise/origin',
          roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestión de Orígenes de Proveedor'
        }  
      ]
    },
    // COURIER
    {
      component: undefined,
      name: 'Courier',
      url: '',
      roles: [SUPER_ADMIN],
      icon: AirportShuttleIcon,
      items: [
        {
          component: CourierCollectionPlannerPage,
          name: 'Planificador',
          url: 'CourierCollection',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Planificador de Colectas'
        },
        {
          component: CourierPage,
          name: 'Configuración',
          url: 'couriers',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Gestion de Couriers y Servicios'
        }
        
      ]
    },
    // Integracion Externa
    {
      component: undefined,
      name: 'Modula',
      url: '',
      roles: [SUPER_ADMIN],
      icon: PrecisionManufacturingIcon,
      items: [
        {
          component: ExternalAuditPage,
          name: 'Monitor',
          url: 'auditlogs',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Monitor de Integración'
        },
        {
          component: RestockOrderPage,
          name: 'Reabastecimiento',
          url: 'restockOrder',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Gestión de Reabastecimientos'
        },
        {
          component: TypePriorityPage,
          name: 'Prioridades',
          url: 'typePriorities',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Gestión de Prioridades'
        }
      ]
    },
    // MARCAS
    {
      component: undefined,
      name: 'Marcas',
      url: '',
      roles: [SUPER_ADMIN],
      icon: SwipeIcon,
      items: [
        {
          component: SettingsPage,
          name: 'Condiciones',
          url: 'settings',
          roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Condiciones de Marca'
        },
        {
          component: ProductOriginPage,
          name: 'Configuración',
          url: 'inventory/productOrigin',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation,
          headerName: 'Configuración de Marca'
        },
      ]
    },
    // USUARIOS
    {
      component: undefined,
      name: 'Usuarios',
      url: '',
      roles: [SUPER_ADMIN],
      icon: PeopleIcon,
      items: [
        {
          component: UserPageNew,
          name: 'Gestión',
          url: 'users-new',
          roles: [SUPER_ADMIN, ADMUSER],
          identation: style.identation,
          headerName: 'Gestión de Usuarios'
        },
        {
          component: UserAdminPage,
          name: 'Configuración',
          url: 'users-configs',
          roles: [SUPER_ADMIN, WAREHOUSE_SUPERVISOR],
          identation: style.identation,
          headerName: 'Configuración de Usuarios'
        }
      ]
    },
    // CONFIGURACIÓN
    {
      component: undefined,
      name: 'Configuración',
      url: '',
      roles: [SUPER_ADMIN],
      icon: TuneIcon,
      items: [
                {
          component: ProductExternalReferencePage,
          name: 'Marca Interna PIM',
          url: 'inventory/productExternalReference',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Gestión de Marca interna PIM'
        },
        {
          component: OrderOriginPage,
          name: 'Canales de Venta',
          url: 'orderOrigin',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Gestión de Canales de Venta'
        },

        {
          component: ProductOriginTechnicalPage,
          name: 'Integraciones de Marca',
          url: 'integrations/brand',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Gestión de Integraciones de Marca'
        },
         {
          component: WebhookPage,
          name: 'Webhooks',
          url: 'webhook',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Gestión de Webhooks'
        },
        {
          component: ConfigurationPage,
          name: 'Avanzada',
          url: 'configuration',
          roles: [SUPER_ADMIN],
          identation: style.identation,
          headerName: 'Configuración Avanzada'
        },
      ]
    },
    {
      component: ProcessNew,
      name: 'Procesos',
      url: 'processCheck',
      items: [],
      roles: [SUPER_ADMIN, WAREHOUSE_SUPERVISOR, ADMIN_CONFIGURATOR],
      icon: AccountTreeIcon
    }
  ]
}
